"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formQuestionOptionsAreSame = void 0;
const formQuestionsAreSame_1 = __importDefault(require("./formQuestionsAreSame"));
const jsonAreSame_1 = __importDefault(require("./jsonAreSame"));
function formQuestionOptionsAreSame(a, b) {
    if (a.id !== b.id)
        return false;
    if (a.value !== b.value)
        return false;
    if (a.label !== b.label)
        return false;
    if (!(0, jsonAreSame_1.default)(a.labelAlt, b.labelAlt))
        return false;
    if (a.flag !== b.flag)
        return false;
    if (a.score !== b.score)
        return false;
    if (a.fail !== b.fail)
        return false;
    if (a.subQuestions.sqId !== b.subQuestions.sqId)
        return false;
    if (a.subQuestions.enabled !== b.subQuestions.enabled)
        return false;
    return (0, formQuestionsAreSame_1.default)(a.subQuestions.questions, b.subQuestions.questions);
}
exports.formQuestionOptionsAreSame = formQuestionOptionsAreSame;
exports.default = formQuestionOptionsAreSame;
